import Typography from "@weave-design/typography";

export const WindowAreaPropertyInfo = () => {
    return <div>
        <Typography>
            Enter window area in <strong>m²</strong> from the <strong>manufacturer&apos;s specification</strong>
        </Typography>
    </div>;
};